import { homepage } from "./getters";

// POSTS

// Set latest posts
export const setLatestPosts = (state, posts) => {
  state.latest_posts = posts;
};

// Set all posts
export const setPosts = (state, posts) => {
  state.all_posts = posts;
};

// Set post
export const setPost = (state, post) => {
  state.post = post;
};

// Set Categories
export const setCategories = (state, categories) => {
  state.categories = categories;
};

// FEATURES

// Set features
export const setFeatures = (state, features) => {
  state.features = features;
};

// FIGHTERS

// Set all fighters
export const setFighters = (state, fighters) => {
  state.fighters = fighters;
};

// Set fighter
export const setFighter = (state, fighter) => {
  state.fighter = fighter;
};

// SCREENSHOTS

// Set screenshots
export const setScreenshots = (state, screenshots) => {
  state.screenshots = screenshots;
};

// WALLPAPERS

// Set wallpapers
export const setWallpapers = (state, wallpapers) => {
  state.wallpapers = wallpapers;
};

// VIDEOS

// Set videos
export const setVideos = (state, videos) => {
  state.videos = videos;
};

// DOWNLOADS

// Set downloads
export const setDownloads = (state, downloads) => {
  state.downloads = downloads;
};

// PAGES

// Set homepage
export const setHomepage = (state, homepage) => {
  state.homepage = homepage;
};

// Set DMCA Policy page
export const setDMCAPolicy = (state, dmcapolicy) => {
  state.dmcapolicy = dmcapolicy;
};

// USER

// Set user
export const setUser = (state, user) => {
  state.user = user;
};

// Set users redeemed code
export const setUserCode = (state, code) => {
  state.user.redeemed = code;
};

// MEDIA

// set medi categories
export const setMediaCategories = (state, categories) => {
  state.mediaCategories = categories;
};

// Set Cookie Policy
export const setCookiePolicy = (state, data) => {
  state.cookiePolicy = data;
};



// WEBPACK FOOTER //
// ./src/store/mutations.js